import React from "react";
import RolesOffered from "./RolesOffered";
import ContactSection from "./ContactSection";   // ✅ src root
import FraudWarning from "../FraudWarning";       // ✅ src root
import "./Internship.css";

export default function Internship() {
  return (
    <>
      {/* 🔹 TOP BANNER IMAGE */}
      <section
        className="internship-banner"
        style={{ backgroundImage: "url(/images/internship.jpg)" }}
      />

      {/* 🔹 ROLES OFFERED */}
      <RolesOffered />

      {/* 🔹 WHY INTERNSHIP SECTION */}
      <section className="why-internship">
        <div className="why-content">
          <h2>Why Internship With Us?</h2>
          <span className="why-line"></span>
          <p>
            Our internship program is designed to give students real-time
            exposure to the insurance and financial services industry.
            You will work closely with experienced professionals, gain
            practical knowledge, and develop skills that prepare you for
            a successful career.
          </p>
        </div>

        <div
          className="why-image"
          style={{ backgroundImage: "url(/images/student.jpg)" }}
        />
      </section>

      {/* 🔹 STIPEND + SELECTION */}
 {/* <StipendSection /> */}


      {/* 🔹 CONTACT SECTION */}
      <ContactSection />

      {/* 🔹 FRAUD / IRDAI WARNING */}
      <FraudWarning />
    </>
  );
}
